<template>
    <div id="app">
        <router-view></router-view>
        <m-dialog
            v-bind="{
                model: 'alert',
                isShow: alert_isShow,
                content: alert_data.content
            }"
            @emit_close="emit_alertClose"
            @emit_ok="emit_alertOk"
        ></m-dialog>
        <m-dialog
            v-bind="{
                model: 'confirm',
                isShow: confirm_isShow,
                content: confirm_data.content
            }"
            @emit_close="emit_confirmClose"
            @emit_ok="emit_confirmOk"
        ></m-dialog>
        <m-dialog
            v-bind="{
                model: 'titleConfirm',
                isShow: titleConfirm_isShow,
                title: titleConfirm_data.title,
                content: titleConfirm_data.content,
                btnCancelText: titleConfirm_data.btnCancelText,
                btnTrueText: titleConfirm_data.btnTrueText
            }"
            @emit_close="emit_titleConfirmClose"
            @emit_ok="emit_titleConfirmOk"
        ></m-dialog>
    </div>
</template>

<script>
import MDialog from '@/components/MDialog';
import { mapGetters, mapMutations, mapActions } from 'vuex';
let SEC = require('common/js/utils/core.js');
import {
    COOKIE_HOST_DOMAIN
} from '@/config';
import {
    ajax_checkUserLogin
} from '@/api';

export default {
    data: () => ({

    }),
    computed: {
        ...mapGetters([
            'alert_isShow',
            'alert_data',
            'confirm_isShow',
            'confirm_data',
            'titleConfirm_isShow',
            'titleConfirm_data',
            'isShowRegisterTip'
        ])
    },
    created(){
    },
    mounted: function(){
    },
    name: 'app',
    methods: {
        emit_alertClose(){
            this.set_alert_hide();
        },
        emit_alertOk(){
            this.alert_data.ok && this.alert_data.ok();
        },
        emit_confirmClose(){
            this.set_confirm_hide();
        },
        emit_confirmOk(){
            this.confirm_data.ok && this.confirm_data.ok();
        },
        emit_titleConfirmClose(){
            this.set_titleConfirm_hide();
        },
        emit_titleConfirmOk(){
            this.titleConfirm_data.ok && this.titleConfirm_data.ok();
        },
        show_alert(data){
            this.$store.dispatch('show_alert', data);
        },
        ...mapMutations({
            set_alert_hide: 'SET_ALERT_HIDE',
            set_confirm_hide: 'SET_CONFIRM_HIDE',
            set_titleConfirm_hide: 'SET_TITLE_CONFIRM_HIDE'
        }),
        ...mapActions([
            'show_alert'
        ])
    },
    components: {
        MDialog
    }
}
</script>

<style lang="scss">
@import './public/style/index.scss';

html, body {
    overflow: hidden;
}
#app {
    position: relative;
    margin: 0 auto;
    max-width: toRem(750);
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue